export default "__VITE_ASSET__B$_lr32r__"